import { render, staticRenderFns } from "./AcquireRequest.vue?vue&type=template&id=a5da8cfa"
import script from "./AcquireRequest.vue?vue&type=script&lang=js"
export * from "./AcquireRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports